// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "1140px";
var _7 = "940px";
var _8 = "100%";
var _9 = "15px";
var _a = "620px";
var _b = "#f53535";
var _c = "rgba(0,0,0,.2)";
var _d = "rgba(255,255,255,.38)";
var _e = ".38";
var _f = "pfx-MessageVerification-module__email-sent-confirmation--OAqV0";
var _10 = "pfx-MessageVerification-module__error-actions--Nkydl";
var _11 = "pfx-MessageVerification-module__error-container--WZYzc";
var _12 = "pfx-MessageVerification-module__error-description--Jtdag";
var _13 = "pfx-MessageVerification-module__error-title--zyxXm";
var _14 = "rgba(255,255,255,.2)";
var _15 = "#0025ff";
var _16 = "pfx-MessageVerification-module__glitch-anim--XNocM";
var _17 = "pfx-MessageVerification-module__glitch-anim-2--yU6qo";
var _18 = "#f60";
var _19 = "#41ead4";
var _1a = "#2cdd78";
var _1b = "#66ab23";
var _1c = "#f5f5f5";
var _1d = "#c3c3c3";
var _1e = "#ececec";
var _1f = "#252525";
var _20 = "#272727";
var _21 = "#c6c6c5";
var _22 = "#333";
var _23 = "#3c3c3c";
var _24 = "#9c9b9b";
var _25 = "#8c8c8c";
var _26 = "#6f6f6e";
var _27 = "#3c3c3b";
var _28 = "#373737";
var _29 = "#6a6a69";
var _2a = "#6f6f6f";
var _2b = "#9f9e9e";
var _2c = "#282828";
var _2d = "#828181";
var _2e = "#1d1d1d";
var _2f = "#979797";
var _30 = "#9c9b9b";
var _31 = "#a7a7a6";
var _32 = "#c6c6c5";
var _33 = "#d8d8d7";
var _34 = "#dddddc";
var _35 = "72px";
var _36 = "40px";
var _37 = "36px";
var _38 = "25px";
var _39 = "18px";
var _3a = "13px";
var _3b = "#0025ff";
var _3c = "rgba(255,255,255,.12)";
var _3d = "#6535f5";
var _3e = "2px";
var _3f = "56px";
var _40 = "56px";
var _41 = "#41ead4";
var _42 = "#f60";
var _43 = "#f83600";
var _44 = "#881f00";
var _45 = "18px";
var _46 = "15px";
var _47 = "pfx-MessageVerification-module__pfx-icon--SMQWk";
var _48 = "red";
var _49 = "pfx-MessageVerification-module__resend-button--Z3N8u";
var _4a = "13px";
var _4b = "rgba(255,255,255,.07)";
var _4c = "#35465c";
var _4d = "#55acee";
var _4e = "pfx-MessageVerification-module__verify-email-prompt--Qdk4b";
var _4f = "#fff";
var _50 = "#ffce36";
var _51 = "#ffcd00";
var _52 = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "containerLarge", _7 as "containerMedium", _8 as "containerMobile", _9 as "containerPaddingMobile", _a as "containerSmall", _b as "danger", _c as "darkElement", _d as "disabled", _e as "disabledOpacity", _f as "emailSentConfirmation", _10 as "errorActions", _11 as "errorContainer", _12 as "errorDescription", _13 as "errorTitle", _14 as "extraLightElement", _15 as "facebook", _16 as "glitchAnim", _17 as "glitchAnim2", _18 as "google", _19 as "green", _1a as "green2", _1b as "greenColor", _1c as "grey1", _1d as "grey10", _1e as "grey2", _1f as "grey25", _20 as "grey27", _21 as "grey3", _22 as "grey33", _23 as "grey3C", _24 as "grey4", _25 as "grey41", _26 as "grey5", _27 as "grey6", _28 as "grey61", _29 as "grey6A", _2a as "grey6F", _2b as "grey7", _2c as "grey8", _2d as "grey82", _2e as "grey9", _2f as "grey97", _30 as "grey9C", _31 as "greyA7", _32 as "greyC6", _33 as "greyD8", _34 as "greyDd", _35 as "header1", _36 as "header2", _37 as "header3", _38 as "header4", _39 as "header5", _3a as "header6", _3b as "klein", _3c as "lightElement", _3d as "lilac", _3e as "menuBorder", _3f as "menuHeight", _40 as "menuMobileHeight", _41 as "ocean", _42 as "orange", _43 as "orange2", _44 as "orangeDark", _45 as "paragraph", _46 as "paragraphSmall", _47 as "pfxIcon", _48 as "red", _49 as "resendButton", _4a as "subHeaderSmall", _4b as "subtleLightElement", _4c as "tumblr", _4d as "twitter", _4e as "verifyEmailPrompt", _4f as "white", _50 as "yellow", _51 as "yellowDeep", _52 as "youtube" }
